"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const PaginationView_1 = __importDefault(require("./PaginationView"));
const DataTableView_1 = __importDefault(require("../../ui/DataTableView"));
function PagedDataTableView(props) {
    const [filterValue, setFilterValue] = react_1.useState(props.defaultFilter);
    let data;
    if (props.isLoading) {
        data = [];
    }
    else {
        data = props.data.map((e) => (Object.assign({ _id: props.header.getUniqueId(e) }, e)));
    }
    const onMouseUp = props.onMouseUp === undefined
        ? (() => { }) : props.onMouseUp;
    const message = props.isLoading ? react_1.default.createElement("div", null, "\u8CC7\u6599\u6B63\u5728\u8F09\u5165\u4E2D...") : '';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.setFilter && (react_1.default.createElement(TextField_1.default, { onKeyDown: (e) => {
                if (e.keyCode === 13) {
                    props.setFilter(filterValue.trim());
                }
            }, onChange: (e) => {
                setFilterValue(e.target.value.trim());
            }, value: filterValue })),
        react_1.default.createElement(PaginationView_1.default, { pageNum: props.pageNum, pageLimit: props.pageLimit, setPageNum: props.setPageNum, setPageLimit: props.setPageLimit }),
        react_1.default.createElement(DataTableView_1.default, { header: props.header, fields: props.fields, data: data, createMouseUpHandler: () => onMouseUp, onMouseDown: () => () => {
            }, selectFilterPath: () => {
            }, onMessageSent: props.onMessageSent }),
        message,
        react_1.default.createElement(PaginationView_1.default, { pageNum: props.pageNum, pageLimit: props.pageLimit, setPageNum: props.setPageNum, setPageLimit: props.setPageLimit })));
}
exports.default = PagedDataTableView;
